var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchedule = function SvgSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 .008A4.98 4.98 0 0 1 9.992 5 4.98 4.98 0 0 1 5 9.992 4.98 4.98 0 0 1 .008 5 4.98 4.98 0 0 1 5 .008m0 9A4.02 4.02 0 0 0 9.008 5 4.02 4.02 0 0 0 5 .992 4.02 4.02 0 0 0 .992 5 4.02 4.02 0 0 0 5 9.008m.258-6.516v2.625l2.25 1.336-.375.633-2.625-1.594v-3z"
  })));
};
export default SvgSchedule;